<template>
  <!-- 登录 -->
  <div id="loginPage">
    <div class="bg">
      <el-carousel
        height="100vh"
        arrow="never"
        interval="5000"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in bg" :key="index">
          <img :src="item" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="bg1"></div>
    <el-card class="box-card">
      <div class="cardBj">
        <div class="switchLogin">用户登录</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
        >
          <div class="input">
            <el-form-item label="公司名称：">
              <el-select
                v-model="selectValue"
                filterable
                :filter-method="searchCompany"
                placeholder="请选择公司"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="username" label="用户名：">
              <el-input
                v-model="ruleForm.username"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码：">
              <el-input
                v-model="ruleForm.password"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="loginBtn">
          <el-button type="success" @click="login">登录</el-button>
        </div>
        <div class="register">
          <span @click="signIn('register')">用户注册</span>
          <span @click="signIn('registerSupplier')">供应商注册</span>
        </div>
      </div>
    </el-card>
    <div class="footer">
      ICP备案号:<a href="https://beian.miit.gov.cn" target="_blank"
        >沪ICP备2024103330号-1</a
      >Copyright &copy; 终端系统-管理后台2025
    </div>
    <div class="top-notice" @click="toggleExpand">
      <div class="notice-wrapper">
        <div
          class="notice-content"
          :class="{ expand: isExpand }"
          ref="noticeContent"
        >
          {{ textContent }}
        </div>
      </div>
      <div class="notice-date">{{ dateText }}</div>
      <div
        class="arrow"
        :class="{ rotate: isNeedExpand && isExpand }"
        v-if="isNeedExpand"
      >
        ▼
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from "@/axios/axiosInstance";
import { getFirstAuthRoute } from "@/router/menuMap";
export default {
  name: "loginPage",
  data() {
    return {
      activeName: "User",
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入手机号或邮箱",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      activeIndex: 0,
      bg: [
        require("@/assets/loginPage/bg1.jpg"),
        require("@/assets/loginPage/bg2.jpg"),
        require("@/assets/loginPage/bg1.jpg"),
        require("@/assets/loginPage/bg2.jpg"),
      ],
      isExpand: false,
      isNeedExpand: false,
      textContent:
        "因系统升级需要，所有用户密码已经修改为默认密码，详细密码请联系售后/管理人员！",
      dateText: "2026年4月1日",
      options: [],
      selectValue: "",
      optionsList: localStorage.getItem("optionsList"),
    };
  },
  created() {
    const permissions = JSON.parse(
      sessionStorage.getItem("permission_codes") || "[]"
    );
    if (this.optionsList) {
      this.options = JSON.parse(this.optionsList);
      this.selectValue = JSON.parse(this.optionsList)[0].id;
    }
    this.defaultActive = getFirstAuthRoute(permissions);
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        const el = this.$refs.noticeContent;
        if (el.scrollWidth > el.offsetWidth) {
          this.isNeedExpand = true;
        }
      });
    }, 100);
  },
  methods: {
    searchCompany(query) {
      if (!query) return;
      axiosInstance
        .get(`/zngcloud/cloud/company/findByCompanyName/${query}`)
        .then((res) => {
          if (res.flag) {
            this.options = res.data || [];
          }
        })
        .catch(() => {
          this.$message({
            message: "网络错误！",
            type: "error",
          });
        });
    },
    // 登录
    login() {
      if (!this.selectValue) {
        this.$message({
          message: "请先选择公司",
          type: "error",
        });
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let query = {
            data: {
              account: this.ruleForm.username,
              password: this.ruleForm.password,
              company_id:
                this.selectValue || JSON.parse(this.optionsList)[0].id,
              login_type: 1,
            },
          };
          axiosInstance
            .post("/zngcloud/user/login/login2cloud", query)
            .then((res) => {
              if (res.flag) {
                const optionsList = this.options.filter((item) => {
                  return item.id === this.selectValue;
                });
                localStorage.setItem(
                  "optionsList",
                  JSON.stringify(optionsList)
                );
                sessionStorage.setItem("token", res.data.token);
                sessionStorage.setItem("username", res.data.user.username);
                sessionStorage.setItem("company_id", res.data.user.company_id);
                sessionStorage.setItem("user_id", res.data.user.user_id);
                sessionStorage.setItem(
                  "permission_codes",
                  JSON.stringify(res.data.permission_codes)
                );
                const userPermissions = res.data.permission_codes || [];
                const targetPath = getFirstAuthRoute(userPermissions);
                this.$router.replace(targetPath);
              } else {
                this.ruleForm.username = "";
                this.ruleForm.password = "";
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.$message({
                message: "网络错误！",
                type: "error",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 注册
    signIn(item) {
      this.$router.push({
        path: "/signIn",
        query: { data: item },
      });
    },
    toggleExpand() {
      if (!this.isNeedExpand) return;
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
#loginPage {
  position: relative;
  width: 100%;
  height: 100%;
}
::v-deep .bg {
  width: 45%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.bg1 {
  width: 55%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-image: url("@/assets/loginPage/loginBj1.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
::v-deep .el-card {
  position: absolute;
  top: 55%;
  left: 75%;
  transform: translate(-50%, -50%);
  width: 30%;
  border-radius: 20px;
  border: none;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.9);
  .cardBj {
    padding: 30px;
    border-radius: 20px;
    .switchLogin {
      width: 100%;
      margin-bottom: 25px;
      font-size: 24px;
      text-align: center;
      font-weight: 700;
    }
    .el-form {
      padding: 0 20px;
      .el-form-item {
        margin-bottom: 25px;
      }
      .el-form-item__label {
        font-size: 20px;
      }
    }
    .loginBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      .el-button {
        font-size: 20px;
        padding: 12px 80px;
      }
    }
    .register {
      display: flex;
      align-items: center;
      justify-content: space-around;
      span {
        color: #409eff;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}
.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 99;
  font-size: 14px;
  a {
    margin-right: 20px;
  }
}
.top-notice {
  width: 55%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 12px 46px 12px 16px;
  line-height: 20px;
  font-size: 14px;
  box-sizing: border-box;
  background-color: #fff7e8;
  color: #f5a623;
  border-bottom: 1px solid #ffd591;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  .notice-wrapper {
    flex: 1;
    min-width: 0;
  }
  .notice-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.5s ease;
  }
  .notice-content.expand {
    white-space: normal !important;
    overflow: visible !important;
  }
  .notice-date {
    white-space: nowrap;
    flex-shrink: 0;
    color: #999;
  }
  .arrow {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    transition: transform 0.3s ease;
    color: inherit;
    pointer-events: none;
  }
  .arrow.rotate {
    transform: translateY(-50%) rotate(180deg);
  }
}

@media screen and (max-width: 768px) {
  .bg {
    display: none !important;
  }
  .bg1 {
    width: 100% !important;
  }
  ::v-deep .el-card {
    width: 85% !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    .cardBj {
      padding: 20px 15px !important;
      .switchLogin {
        font-size: 18px !important;
        margin-bottom: 20px !important;
        ul li {
          line-height: 1.5 !important;
        }
      }
      .el-form {
        padding: 0 !important;
        .el-form-item__label {
          font-size: 14px !important;
        }
        .el-input__inner {
          height: 40px !important;
          font-size: 14px !important;
        }
      }
      .loginBtn .el-button {
        font-size: 18px;
      }
    }
  }
  .footer {
    font-size: 10px !important;
    padding: 6px 0 !important;
    a {
      margin-right: 8px !important;
    }
  }
  .top-notice {
    width: 100% !important;
    padding: 10px 40px 10px 12px !important;
    font-size: 12px !important;
    line-height: 18px !important;
    .notice-date {
      font-size: 11px !important;
    }
    .arrow {
      right: 12px !important;
    }
  }
}
</style>
